import * as API from '../data/price_list_api';
import {signOutAction} from "./auth_actions";

export const CLERK_PRICELIST = 'get_clerk_pricelist';
export const CLERK_PRICELIST_UPDATE = 'update_clerk_pricelist';
export const COMPANY_PRICELIST = 'get_company_pricelist';
export const COMPANY_PRICELIST_UPDATE = 'update_company_pricelist';
export const CLEAR_DATA = 'clear_cached_data';

export function getCompanyPriceList(id, type) {
    return async (dispatch) => {
        if(id){
            dispatch({type:CLEAR_DATA})
        }
        const response = await API.getCompanyPriceList(id, type);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: COMPANY_PRICELIST, payload: response});
        }
    }
}

export function updateCompanyPriceList(priceId, price, companyId, type) {
    return async (dispatch) => {
        const response = await API.updateCompanyPriceList(priceId, price);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: COMPANY_PRICELIST_UPDATE, payload: response});
            this.getCompanyPriceList(companyId, type);
        }
    }
}

export function getClerkPriceList(type) {
    return async (dispatch) => {
        dispatch({type:CLEAR_DATA});
        const response = await API.getClerkPriceList(type);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: CLERK_PRICELIST, payload: response});
        }
    }
}

export function updateClerkPriceList(priceId, price,type) {
    return async (dispatch) => {
        const response = await API.updateClerkPriceList(priceId, price);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: CLERK_PRICELIST_UPDATE, payload: response});
            this.getClerkPriceList(type);
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/price_list_action.js